/**
 * Undoes URL-encoding in a user-facing file name ("Boarding%20Pass.pdf" ->
 * "Boarding Pass.pdf").
 *
 * Files sent from the iOS app were stored with percent-encoded names. Only
 * decodes when the name actually contains an escape, and falls back to the
 * raw name when it isn't valid encoding (e.g. a literal "50% off.pdf").
 */
export const decodeFileName = (name) => {
  if (typeof name !== "string" || !/%[0-9A-Fa-f]{2}/.test(name)) return name;
  try {
    return decodeURIComponent(name);
  } catch {
    return name;
  }
};
